module.exports = __webpack_public_path__ + "static/img/duoimg.69532df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/gongchengshi/duoimg.png
// module id = dcVC
// module chunks = 6